<template>
  <qx-card title="列表">
    <LogRightDialog
      ref="logRightDialog"
      busiCode="100002"
    />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleT able"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'loginAcct'" @click="toDriverDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section v-if="scope.column.property === 'attachTenantName'">
                <span
                  v-if="scope.row.attachTenantId !== -1 && scope.row.attachTenantName"
                  class="primary cur"
                  @click="toTenantDetail(scope.row)"
                >
                  {{scope.row[scope.column.property]}}
                </span>
                <span v-else>{{scope.row[scope.column.property]}}</span>
              </section>
              <section
                v-if="scope.column.property !== 'attachTenantName' && scope.column.property !== 'loginAcct'"
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="80">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.relId)">日志</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import {
  driverArchivesHistoryList,
} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'loginAcct',
            label: '司机账号',
          },
          {
            prop: 'linkman',
            label: '司机名称',
          },
          {
            prop: 'carUserTypeName',
            label: '司机类型',
          },
          {
            prop: 'attachTenantName',
            label: '归属车队',
          },
          {
            prop: 'attachTennantLinkman',
            label: '车队联系人',
          },
          {
            prop: 'attachTennantLinkPhone',
            label: '车队电话',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverArchivesHistoryList,
    toDriverDetail (item) {
      this.jump({
        label: '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${item.userId}`,
        full: true,
      });
    },
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.attachTenantId}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
